import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface CookieState {
  [key: string]: string
}

export const cookiesSlice = createSlice({
  initialState: {},
  name: 'cookies',
  reducers: {
    setCookie: (state, { payload }: PayloadAction<Record<string, string>>) => ({
      ...state,
      ...payload,
    }),
  },
})

export default cookiesSlice.reducer
